/**
 * Annoncer ce que l'appareil a répondu, après un ajout ou une modification d'actif.
 *
 * POURQUOI UN SEUL ENDROIT. Le serveur interroge désormais l'appareil aux deux gestes de
 * la fiche client (lot L2, retour 2.1 de David : une PAC ajoutée restait « inconnue »
 * sans que rien ne le dise). Les deux toasts disent donc la même chose, de la même façon.
 *
 * Un appareil muet s'annonce en avertissement, plus longtemps : c'est le cas où celui
 * qui saisit doit agir (vérifier le numéro, l'alimentation), et le rattrapage le
 * listera. Sans verdict (aucun identifiant saisi), on ne dit rien de la machine.
 */
export function annoncerVerdict(toast, prefixe, verdict) {
  if (!verdict) {
    toast.success(prefixe);
    return;
  }
  (verdict.vivant ? toast.success : toast.warning)(
    `${prefixe} : ${verdict.message}`, { duration: verdict.vivant ? 5000 : 12000 });
}
